/**
 * 是否为app端
 * @returns true : 是
 */
export function isApp() {
  return navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
}

/**
 * 获取mac地址
 * @returns {string}
 */
export function mac() {
  if(localStorage.getItem("mac")){
    return localStorage.getItem("mac");
  }

  const os = require("os");
  let mac = ''
  let networkInterfaces = os.networkInterfaces();
  for (let i in networkInterfaces) {
    for (let j in networkInterfaces[i]) {
      if (networkInterfaces[i][j]["family"] === "IPv4" && networkInterfaces[i][j]["mac"] !== "00:00:00:00:00:00" && networkInterfaces[i][j]["address"] !== "127.0.0.1") {
        mac = networkInterfaces[i][j]["mac"]
      }
    }
  }
  if(!mac){
    mac = uuid()
  }
  localStorage.setItem("mac", mac)
  return mac

}

export function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  }) + Math.floor(Math.random() * 10000 + 1);
}

export function changeURLStatic(name, value) {
  var url = location.href
  var reg = eval('/([?|&]' + name + '=)[^&]*/gi')
  value = value.toString().replace(/(^\s*)|(\s*$)/g, '') // 移除首尾空格
  if (!value) {
    var url2 = url.replace(reg, '') // 正则替换
  } else {
    if (url.match(reg)) {
      var url2 = url.replace(reg, '$1' + value) // 正则替换
    } else {
      var url2 =
        url + (url.indexOf('?') > -1 ? '&' : '?') + name + '=' + value // 没有参数添加参数
    }
  }
  history.replaceState(null, null, url2) // 替换地址栏
}



// WEBPACK FOOTER //
// ./src/utils/util.js